import { cn, ClassValue } from "@/libs/utils/tailwind/cn";

export default function GuaranteedIcon({ className }: Props) {
  return (
    <svg
      className={cn("size-10 text-primary", className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M15.0003 19.9997L18.3337 23.333L25.0003 16.6663M33.3337 21.6671C33.3337 30.0004 27.5003 34.1671 20.567 36.5838C20.2039 36.7068 19.8096 36.7009 19.4503 36.5671C12.5003 34.1671 6.66699 30.0004 6.66699 21.6671V10.0004C6.66699 9.5584 6.84259 9.13447 7.15515 8.82191C7.46771 8.50935 7.89163 8.33376 8.33366 8.33376C11.667 8.33376 15.8337 6.33376 18.7337 3.80042C19.0867 3.49875 19.5359 3.33301 20.0003 3.33301C20.4647 3.33301 20.9139 3.49875 21.267 3.80042C24.1837 6.35042 28.3337 8.33376 31.667 8.33376C32.109 8.33376 32.5329 8.50935 32.8455 8.82191C33.1581 9.13447 33.3337 9.5584 33.3337 10.0004V21.6671Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface Props {
  className?: ClassValue;
}
